<script>

    import Moment from 'moment'
    import { toast } from 'bulma-toast'
    import { pickupsStore, shipmentStore, modalStore } from '../stores'

    import PickupsService from '../$services/pickups.service'
    import RedpackService from '../$services/redpack.service'

    import Select from '../$components/select.svelte'
    import Spinner from '../$components/spinner.svelte'
    import Date from '../$components/date.svelte'

    let loading = false
    let colonies = []

    const data = {
        provider: $shipmentStore.provider,
        guide: $shipmentStore.guide,
        package: {
            width: $shipmentStore.order.package.width,
            height: $shipmentStore.order.package.height,
            length: $shipmentStore.order.package.length,
            weight: $shipmentStore.order.package.weight,
            value: $shipmentStore.order.package.value,
            content: $shipmentStore.order.package.content,
        },
        location: {
            contact: $shipmentStore.order.pickup.contact,
            rfc: $shipmentStore.order.pickup.rfc,
            corporate: $shipmentStore.order.pickup.corporate,
            phone: $shipmentStore.order.pickup.phone,
            email: $shipmentStore.order.pickup.email,
            zipcode: $shipmentStore.order.pickup.zipcode,
            state: $shipmentStore.order.pickup.state,
            city: $shipmentStore.order.pickup.city,
            municipality: $shipmentStore.order.pickup.municipality,
            colony: $shipmentStore.order.pickup.colony,
            street: $shipmentStore.order.pickup.street,
            number: $shipmentStore.order.pickup.number,
            apartment: $shipmentStore.order.pickup.apartment,
            references: $shipmentStore.order.pickup.references
        }
    }

    async function createPickup() {

        loading = true
        const resp = await PickupsService.createPickup(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger', duration: 5000})

        pickupsStore.append(resp.data)
        toast({message: 'Recolección creada', type: 'is-success'})
        modalStore.close()
    }

    if(data.provider === 'Redpack')
        getColonies()

    async function getColonies() {

        loading = true
        const resp = await RedpackService.getColonies({zipcode: data.location.zipcode})
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        colonies = resp.data
    }

</script>

<Spinner {loading} />

{#if !loading}
    <form on:submit|preventDefault={createPickup}>
        <div class="columns">
            <div class="column">
                <label for="" class="label">Cantidad de paquetes</label>
                <div class="field">
                    <div class="control has-icons-left">
                        <span class="icon"><i class="fas fa-address-book"></i></span>
                        <input bind:value={data.packageTotal} type="number" min="1" class="input" placeholder="Cantidad de paquetes a recolectar" required>
                    </div>
                </div>
            </div>
        </div>
        {#if colonies.length}
            <div class="columns">
                <div class="column">
                    <Select 
                        bind:value={ data.location.colony }
                        label="Colonia" 
                        icon="map-marker-alt"
                        options={colonies.map(colony => {
                            return {value: colony.name, text: colony.name}
                        })}
                    />
                </div>
            </div>
        {/if}
        <div class="columns">
            <div class="column">
                <Date bind:value={data.date} label="Fecha de recolección"/>
                <div class="notification is-warning">
                    La mayoría las recolecciones registradas el mismo día no serán procesadas después de las 12pm.
                </div>
            </div>
        </div>
        <div class="items-end">
            <div class="buttons">
                <button on:click={() => modalStore.set('shipment_modal')} type="button" class="button space-right">
                    <span class="icon"><i class="fas fa-ban"></i></span>
                    <span>Cancelar</span>
                </button>
                <button type="submit" class="button is-primary">
                    <span class="icon"><i class="fas fa-save"></i></span>
                    <span>Guardar</span>
                </button>
            </div>
        </div>
    </form>
{/if}